function media() {

  const cards = document.querySelectorAll('.card');
  const background = document.getElementById('background');
  const mediaElements = document.querySelectorAll('.media');
  let leaveTimeout;

  if (!cards.length || !background || !mediaElements.length) {
    return;
  }

  cards.forEach(card => {
    card.addEventListener('mouseenter', () => {
      clearTimeout(leaveTimeout);

      const slug = card.dataset.media;
      if (!slug) return;

      background.style.display = 'none';

      mediaElements.forEach(media => {
        media.style.display = 'none';
      });

      const targetMedia = document.querySelector(`.media[data-media="${slug}"]`);
      if (targetMedia) {
        targetMedia.style.display = 'block';
        const video = targetMedia.querySelector('video');
        if (video) {
          const source = video.querySelector('source');
          // Si el video no tiene 'src', es la primera vez. Cárgalo.
          if (source && !source.getAttribute('src')) {
            const videoSrc = source.dataset.src;
            if (videoSrc) {
              source.src = videoSrc;
              video.load();
              // Espera a que se pueda reproducir para evitar errores
              video.addEventListener('canplay', () => {
                video.play();
              }, { once: true });
            }
          } else {
            // Si ya tiene 'src', solo reprodúcelo
            video.play();
          }
        }
      }
    });

    card.addEventListener('mouseleave', () => {
      leaveTimeout = setTimeout(() => {
        mediaElements.forEach(media => {
          media.style.display = 'none';
          const video = media.querySelector('video');
          if (video) {
            video.pause();
            video.currentTime = 0; // Rebobina el video
          }
        });

        background.style.display = 'block';
      }, 50);
    });
  });

}

export default media
